<script setup lang="ts">
import { deletePayslipInput } from '@/api/payslipInputs'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import { useToasts } from '@/core/composables/useToasts'
import { useI18n } from 'vue-i18n'

interface Props {
  /** The ID of the payslip input to delete */
  payslipInputId: number
}

const props = defineProps<Props>()

const emit = defineEmits<{
  /** Emitted when salary is deleted successfully */
  deleted: []
  /** Emitted when deletion fails */
  error: []
}>()

defineOptions({
  name: 'SalaryDeletionDialog'
})

const { t } = useI18n()
const { addSuccessToast, addDangerToast } = useToasts()

const deleteSalary = async ({
  close
}: CardDialogActionParams): Promise<void> => {
  try {
    await deletePayslipInput(props.payslipInputId)
    addSuccessToast({ content: t('salary.success.delete') })
    emit('deleted')
  } catch (error) {
    addDangerToast({ content: t('salary.errors.delete') })
    console.error(error)
    emit('error')
  } finally {
    close()
  }
}
</script>

<template>
  <ConfirmDialog :title="t('salary.actions.delete')" @action="deleteSalary">
    <p>{{ t('salary.confirm.delete_draft') }}</p>
    <template #action>
      {{ t('general.delete') }}
    </template>
  </ConfirmDialog>
</template>
